import { StudyWorkflowModules } from 'interfaces/study';
import { isBoolean } from 'lodash';

export type StudyWorkflowConfiguration = Required<StudyWorkflowModules>;

export type StudyWorkflowConfigurationKey = keyof StudyWorkflowConfiguration;

export const defaultStudyWorkflowConfiguration: StudyWorkflowConfiguration = {
  rnaProbes: false,
  markerPositivity: true,
  cellRulesBasedCellTyping: true,
};

export const getStudyWorkflowConfiguration = (modules?: StudyWorkflowModules): StudyWorkflowConfiguration => {
  const cellRulesBasedCellTyping = isBoolean(modules?.cellRulesBasedCellTyping)
    ? modules.cellRulesBasedCellTyping
    : defaultStudyWorkflowConfiguration.cellRulesBasedCellTyping;
  const markerPositivity = cellRulesBasedCellTyping
    ? true
    : isBoolean(modules?.markerPositivity)
    ? modules.markerPositivity
    : defaultStudyWorkflowConfiguration.markerPositivity;

  return {
    rnaProbes: isBoolean(modules?.rnaProbes) ? modules.rnaProbes : defaultStudyWorkflowConfiguration.rnaProbes,
    markerPositivity,
    cellRulesBasedCellTyping,
  };
};

export const isRnaOnlyStudyWorkflow = (modules?: StudyWorkflowModules) => {
  const configuration = getStudyWorkflowConfiguration(modules);

  return configuration.rnaProbes && !configuration.cellRulesBasedCellTyping;
};

export const updateStudyWorkflowConfiguration = (
  configuration: StudyWorkflowConfiguration,
  key: StudyWorkflowConfigurationKey,
  enabled: boolean
): StudyWorkflowConfiguration => {
  if (key === 'markerPositivity' && !enabled) {
    return {
      ...configuration,
      markerPositivity: false,
      cellRulesBasedCellTyping: false,
    };
  }

  if ((key === 'rnaProbes' || key === 'cellRulesBasedCellTyping') && enabled) {
    return {
      ...configuration,
      [key]: true,
      markerPositivity: true,
      cellRulesBasedCellTyping: true,
    };
  }

  return { ...configuration, [key]: enabled };
};
